export default __webpack_public_path__ + "static/media/login-bacground.06b3bb4d.png";